var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'businesstype-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      usertypeName: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    businesstypes () {
      return this.$store.getters.businesstypeList
    },
    nextPage () {
      return this.$store.getters.businesstypeListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.businesstypeListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {'user_type_name': this.usertypeName}
      this.$store.dispatch('BUSINESS_TYPE_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goBusinessTypeNew: function () {
      this.$router.push({ path: '/business_types/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goBusinessTypeEdit: function(businesstypeId) {
      this.$router.push({ path: '/business_types/' + businesstypeId + '/edit'})
    },
    businesstypeDelete: function(businesstypeId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('BUSINESS_TYPE_DELETE',  {id: businesstypeId, callback: this.onSaved})
      }
    },
    content: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    },
    half: function () {
      this.usertypeName = utils.emHalf(this.usertypeName)
    },
    onSaved: function (result) {
      this.$router.push('/business_types')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/businesstype-list.js